import { FunctionComponent } from "react";
import { useStepScope } from "../stepped-modal-step-scope";
import type { IProps } from "./stepped-modal-formik-step.types";

/**
 * Declares one step of a SteppedModal.Formik. The modal renders every step so each can declare its
 * rules, but only the active step renders its children — inactive steps cost nothing. `label`,
 * `nextButtonText` and `validation` are read from this element by the modal rather than used here.
 */
const SteppedModalFormikStep: FunctionComponent<IProps> = ({ children }) => {
    const { isActive } = useStepScope();
    return isActive ? <>{children}</> : null;
};

export { SteppedModalFormikStep };
